/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { Approval, ApprovalRequestType, ListData, Maybe } from '../data/types.generated';

export const filterAgentAndAppApprovals = (approvals: Maybe<Approval>[], listData: ListData): Maybe<Approval>[] => {
    const selectedAppId =
        listData.approvalType === ApprovalRequestType.AgentAndAppApprovals ? listData.extendedParameters?.appId : null;

    return selectedAppId
        ? approvals.filter((approval: Maybe<Approval>): boolean =>
              approval?.selectors?.some(
                  (selector): boolean => selector?.queryParameterKey === 'appId' && selector.optionId === selectedAppId
              )
          )
        : approvals;
};
